import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, Slides, ViewController, Content, ToastController, AlertController } from 'ionic-angular';
import { AuthData } from '../../providers/auth';
import { EventData } from '../../providers/event';
import { Database } from '../../providers/database';
import { Translate } from '../../providers/translate';

@Component({
  selector: 'page-event-opinometer',
  templateUrl: 'event-opinometer.html'
})

export class EventOpinometerPage {
  @ViewChild(Slides) slides: Slides;
  @ViewChild(Content) content: Content;

  event: any;
  client: any;
  opinometerData: any;
  stateOpinometer: any = null;
  textTranslate: any;
  loader: any;
  isEnd: any = false;

  constructor(public navCtrl: NavController, public params: NavParams, public auth: AuthData, public eventProvider: EventData, public db: Database, public loading: LoadingController, translate: Translate, public view: ViewController, public toast: ToastController, public alertCtrl: AlertController) {
    translate.translateGroup(['Cargando', 'Se han enviado sus preguntas correctamente', 'Ok', '¿Desea enviar las respuestas?', 'Cancelar', 'Enviar'])
    .then(result => {
      this.textTranslate = result;
    });

    this.event = this.params.get('event');
    this.client = this.params.get('client');
    this.opinometerData = this.params.get('opinometer');

    this.db.getData('/Clients/' + this.client.url + '/___OpinometersUsers/' + this.opinometerData.id + '/' + this.auth.getUser().uid).then((result: any) => {
      if (result.val()) {
        this.opinometerData['answersUser'] = result.val();
        this.stateOpinometer = false;
        this.loader.dismiss();
      } else {
        setTimeout(() => {
          this.stateOpinometer = true;
          this.loader.dismiss();
        }, 500);
      }
    });
  }

  send() {
    let resultData: any = [];
    let loader = this.loading.create({
      content: this.textTranslate['Cargando']
    });
    loader.present();

    for (var key in this.opinometerData.Questions) {
      let question = this.opinometerData.Questions[key];

      switch (question.type) {
        case 'multiple':
          let tmp = [];

          question.answers.forEach((answer: any, k) => {
            tmp[k] = answer.isChecked || false;

            if (answer.isChecked) {
              this.eventProvider.setTransactionOpinometer('multiple', this.client, this.opinometerData, question, k);
            }
          });

          resultData[question.id] = tmp;
        break;
        case 'multipleUnique':
          resultData[question.id] = question.answerData || false;

          if (question.answerData) {
            this.eventProvider.setTransactionOpinometer('multipleUnique', this.client, this.opinometerData, question, question.answerData);
          }
        break;
        case 'ranking':
          resultData[question.id] = question.answerData || false;

          if (question.answerData) {
            this.eventProvider.setTransactionOpinometer('ranking', this.client, this.opinometerData, question, false);
          }
        break;
        case 'open':
          resultData[question.id] = question.answerData || false;

          if (question.answerData) {
            this.eventProvider.setTransactionOpinometer('open', this.client, this.opinometerData, question, false);
          }
        break;
      }
    }

    this.db.updateData('/Clients/' + this.client.url + '/___OpinometersUsers/' + this.opinometerData.id + '/' + this.auth.getUser().uid, resultData).then(() => {
      let toast = this.toast.create({
        message: this.textTranslate['Se han enviado sus preguntas correctamente'],
        duration: 5000,
        closeButtonText: this.textTranslate['Ok'],
        showCloseButton: true
      });
      loader.dismiss().then(() => {
        toast.present();
        this.close();
      });
    });
  }

  onModelChange(event) {
    if (event) {
      if (this.isEnd) {
        // Alert
        let alert = this.alertCtrl.create({
          title: this.event.title,
          message: this.textTranslate['¿Desea enviar las respuestas?'],
          buttons: [{
            text: this.textTranslate['Cancelar'],
            handler: () => {}
          },{
            text: this.textTranslate['Enviar'],
            handler: () => {
              this.send();
            }
          }]
        });

        alert.present();
      } else {
        this.next();
      }
    }
  }

  updateMultiple(question, key) {
    if (!question.answerData) {
      question.answerData = [];
    }

    question.answerData.push(key);
  }

  validateMultiple(question) {
    let flag = false;

    question.answers.forEach((a) => {
      if (a.isChecked) {
        flag = true;
      }
    });

    if (flag) {
      question.answerData = true
    } else {
      question.answerData = false
    }
  }

  next() {
    this.slides.lockSwipes(false);
    this.slides.slideTo(this.slides.getActiveIndex() + 1);
    this.slides.lockSwipes(true);
  }

  prev() {
    this.slides.lockSwipes(false);
    this.slides.slideTo(this.slides.getActiveIndex() - 1);
    this.slides.lockSwipes(true);
  }

  slideChanged() {
    this.content.scrollToTop(100);
    this.isEnd = this.slides.isEnd();
  }

  ngAfterViewInit() {
    this.loader = this.loading.create();
    this.loader.present();
  }

  close() {
    this.view.dismiss();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-opinometer/event-opinometer.ts